import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { BASE_URL } from "../../config/axios";
import { formatDateDD_MM_YYYY } from "../Date";
import { DocumentModel } from "./ProjectDetailsCrudButtons";

const AllAssociatedLetters = ({ id, project, workperformedby, lettertype, buttonUI }) => {
    const [allLetters, setAllLetters] = useState([]);
    const [networkLetters, setNetworkLetters] = useState([]);
    const [show, setShow] = useState(false);
    const [hiddenLetters, setHiddenLetters] = useState(new Set());
    const [hiddenByLetter, setHiddenByLetter] = useState({});

    const [showDocuments, setShowDocuments] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [buffer, setBuffering] = useState(false);

    // ---- Recursive function to get full network (up + down) ----
    const collectFullNetwork = (letterId, data, visited = new Set()) => {
        if (!letterId || visited.has(letterId)) return [];
        visited.add(letterId);

        const letter = data.find(l => l.id === letterId);
        if (!letter) return [];

        let network = [letter];

        // Downstream: children / associated letters
        if (letter.associated_letters_details) {
            letter.associated_letters_details.forEach(assoc => {
                network = network.concat(collectFullNetwork(assoc.id, data, visited));
            });
        }

        // Upstream: parents
        const parents = data.filter(l =>
            l.associated_letters_details?.some(a => a.id === letter.id)
        );
        parents.forEach(parent => {
            network = network.concat(collectFullNetwork(parent.id, data, visited));
        });

        return network;
    };

    // ---- Fetch letters from API ----
    const fetchLetters = async () => {
        setBuffering(true);

        try {
            const response = await axios.get(
                `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${workperformedby}/${lettertype}/`
            );
            const data = response.data;
            setAllLetters(data);

            const fullNetwork = collectFullNetwork(id, data);
            const uniqueNetwork = [...new Map(fullNetwork.map(l => [l.id, l])).values()];
            setNetworkLetters(uniqueNetwork);
        } catch (error) {
            console.error("Error fetching letters:", error);
        } finally {
            setBuffering(false);// End Buffering

        }
    };

    useEffect(() => {
        if (show) fetchLetters();
    }, [show]);

    // ---- Sort network letters by date ascending ----
    const sortedByDate = [...networkLetters].sort((a, b) => new Date(a.letter_date) - new Date(b.letter_date));





    // ---- Check if this letter is associated with any other ----
    const isAssociatedInNetwork = (letterId) => {
        return networkLetters.some(l => l.associated_letters_details?.some(a => a.id === letterId));
    };

    // ---- Hide / Restore logic ----
    const collectReverseNetwork = (selectedIds, data, visited = new Set()) => {
        let toHide = new Set();
        selectedIds.forEach(selId => {
            data.forEach(letter => {
                if (!visited.has(letter.id) && letter.associated_letters_details?.some(a => a.id === selId)) {
                    toHide.add(letter.id);
                    visited.add(letter.id);
                    collectReverseNetwork([letter.id], data, visited).forEach(id => toHide.add(id));
                }
            });
        });
        return toHide;
    };

    const handleHide = (letterId) => {
        const idsToHide = collectReverseNetwork([letterId], networkLetters);
        if (idsToHide.size === 0) return;
        setHiddenLetters(prev => new Set([...prev, ...idsToHide]));
        setHiddenByLetter(prev => ({ ...prev, [letterId]: idsToHide }));
    };

    const handleRestore = (letterId) => {
        const idsToRestore = hiddenByLetter[letterId] || new Set();
        setHiddenLetters(prev => {
            const newSet = new Set([...prev]);
            idsToRestore.forEach(id => newSet.delete(id));
            return newSet;
        });
        setHiddenByLetter(prev => {
            const copy = { ...prev };
            delete copy[letterId];
            return copy;
        });
    };

    const handleHideAll = () => {
        setHiddenLetters(new Set());
        setHiddenByLetter({});
    };


    // Step 1: Har letter ka default level -1
    const levelMap = {}; // id -> level mapping

    sortedByDate.forEach((l, index) => {
        const currentId = l.id;

        // agar pehle se level set nahi hai to root letter ko 0 do
        if (levelMap[currentId] === undefined) {
            levelMap[currentId] = 0;
        }

        sortedByDate.forEach(other => {
            if (other.associated_letters_details?.some(a => a.id === currentId)) {
                // agar mila to iska level = parent + 1
                levelMap[other.id] = (levelMap[currentId] ?? 0) + 1;

                console.log(
                    `👉 Letter ${l.letter_num} (ID ${currentId}, Level ${levelMap[currentId]}) found inside ${other.letter_num} (ID ${other.id}, Level ${levelMap[other.id]})`
                );
            }
        });
    });

    console.log("📌 Final Levels (date-wise):");
    sortedByDate.forEach(l => {
        console.log(
            `Letter ${l.letter_num} (ID: ${l.id}) | Level: ${levelMap[l.id]}`
        );
    });



    return (
        <>
            {buttonUI === "normal" ?
                <button
                    style={{ fontSize: "12px" }}
                    onClick={handleShow}>            <span className="view-text">View</span>
                </button>
                : <button className="eyebutton" onClick={handleShow}>view</button>
            }
            <Modal show={show} onHide={handleClose} dialogClassName="model-width60vw">

                <Modal.Header closeButton>
                    <Modal.Title>Full Letter Network</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Modal.Body>
                        {/* 🌀 Always show loader when buffering */}
                        {buffer ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "300px",
                                }}
                            >
                                <div
                                    className=" spinner-bgdatil text-primary "
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                {networkLetters.length === 0 && <p>No letters found.</p>}

                                {networkLetters.length > 0 && (
                                    <>
                                        <div className="scroll-container">
                                            <div
                                                className="scrollbar"
                                                style={{ width: `100%`, paddingLeft: "10px", paddingTop: "10px" }}
                                            >
                                                {sortedByDate.map((letter) => {
                                                    if (hiddenLetters.has(letter.id)) return null;
                                                    const isAssociated = isAssociatedInNetwork(letter.id);
                                                    const level = levelMap[letter.id] || 0;

                                                    return (
                                                        <div
                                                            className="book"
                                                            key={letter.id}
                                                            style={{
                                                                padding: "20px",
                                                                marginBottom: "40px",
                                                                marginLeft: `${level * 40}px`,
                                                                width: `40%`,
                                                                backgroundColor: id === letter.id ? "#4caf50" : "whitesmoke",
                                                                color: id === letter.id ? "white" : "black",
                                                            }}
                                                        >
                                                            <div
                                                                className="flex-row justify-between"
                                                                style={{ width: "100%" }}
                                                            >
                                                                {isAssociated && (
                                                                    <>
                                                                        {!hiddenByLetter[letter.id] && (
                                                                            <button
                                                                                className="viewbutton"
                                                                                onClick={() => handleHide(letter.id)}
                                                                            >
                                                                                Hide Associated Letters
                                                                            </button>
                                                                        )}
                                                                        {hiddenByLetter[letter.id] && (
                                                                            <button
                                                                                className="viewbutton"
                                                                                onClick={() => handleRestore(letter.id)}
                                                                            >
                                                                                Show Associated Letters
                                                                            </button>
                                                                        )}
                                                                    </>
                                                                )}

                                                                <DocumentModel
                                                                    letterData={letter}
                                                                    letterrecord={letter.id}
                                                                    documents={showDocuments}
                                                                    setDocuments={setShowDocuments}
                                                                    title="Letter Documents"
                                                                />
                                                            </div>

                                                            <div
                                                                className="cover"
                                                                style={{
                                                                    backgroundColor:
                                                                        id === letter.id ? "#4caf50" : "whitesmoke",
                                                                    color: id === letter.id ? "white" : "black",
                                                                }}
                                                            >
                                                                <div
                                                                    className="flex-row justify-between"
                                                                    style={{ alignItems: "start", width: "100%" }}
                                                                >
                                                                    <div style={{ padding: `10px` }}>
                                                                        <p
                                                                            className="text-start"
                                                                            style={{ textTransform: "capitalize" }}
                                                                        >
                                                                            <strong>Letter Number:</strong> {letter.letter_num} <br />
                                                                            <strong>Letter Exchange Type:</strong>{" "}
                                                                            {letter.letterExchange} <br />
                                                                            <strong>Date:</strong>{" "}
                                                                            {formatDateDD_MM_YYYY(letter.letter_date)} <br />
                                                                            <strong>Letter Type:</strong> {letter.lettertype} <br />
                                                                            <strong>Status:</strong> {letter.status}
                                                                            <br />
                                                                            <strong>Reply of Letter Number:</strong>{" "}
                                                                            {letter.associated_letters_details
                                                                                ?.map((i) => i.letter_num)
                                                                                .join(", ")}
                                                                            <br />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {hiddenLetters.size > 0 && (
                                            <button className="viewbutton" onClick={handleHideAll}>
                                                Show All Letters
                                            </button>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Modal.Body>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default AllAssociatedLetters;
